// 首页
import Axios from "@/assets/js/ajax";
import {
  getUserInforUrl,
  setUserInforUrl,
  getUserPostUrl,
  getUserAuditPostUrl,
} from "@/assets/js/const";
const state = {
  userInfor: {}, // 用户信息 初始化一个对象
  userPosts: [], // 用户文章,
  userAuditPosts: {}, //待审核文章
};

const getters = {
  userInfor: (state) => state.userInfor,
  userPosts: (state) => state.userPosts,
  userAuditPosts: (state) => state.userAuditPosts,
};

const mutations = {
  setUserInfor(state, payload) {
    state.userInfor = payload;
  },
  setUserPostList(state, payload) {
    state.userPosts = payload;
  },
  setUserAuditPosts(state, payload) {
    state.userAuditPosts = payload;
  },
};

const actions = {
  async getUserInfor({ commit }, uid) {
    let { data } = await Axios.get(getUserInforUrl + "?uid=" + uid);

    try {
      commit("setUserInfor", data.data.userInfor);
    } catch (error) {}
  },
  async setUserDetailInfo({ dispatch }, payload) {
    await Axios.post(setUserInforUrl, payload);
    dispatch("getUserInfor");
    dispatch("home/initApp", null, { root: true });
  },
  async getUserPostList({ commit }, user_id) {
    let { data } = await Axios.get(getUserPostUrl + "/" + user_id);
    try {
      commit("setUserPostList", data.data.posts);
    } catch (error) {}
  },
  async getUserAuditPosts({ commit }) {
    let { data } = await Axios.get(getUserAuditPostUrl);
    try {
      commit("setUserAuditPosts", data.data.posts);
    } catch (error) {}
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
